import { Subject, SubjectSearchResult } from '../_interfaces/subject';

/**
 * Fields the schedule list (`allSubjects=false`) does not return. Copied from the
 * `allSubjects=true` search hit after a scheduled patient is selected. Add a key here
 * to include it; `formatPatient` must also persist it onto copilot if it is not already mapped.
 */
export const SCHEDULE_SUBJECT_FIELDS = ['subject_sex', 'subject_death_indicator'] as const satisfies readonly (keyof Subject)[];

export interface ScheduleSubjectLookupApi {
  getSubjects(params: {
    allSubjects: true;
    searchQuery?: string;
    searchLimit?: number;
  }): Promise<SubjectSearchResult>;
}

export async function enrichScheduledSubject(
  api: ScheduleSubjectLookupApi,
  patient: Subject,
): Promise<Subject> {
  const subjectId = patient.subject_id?.trim();
  if (!subjectId) return patient;

  try {
    const search = await api.getSubjects({
      allSubjects: true,
      searchQuery: subjectId,
      searchLimit: 5,
    });
    const match = (search?.rows ?? []).find(row => row.subject_id?.trim() === subjectId);
    if (!match) return patient;

    const extra = Object.fromEntries(
      SCHEDULE_SUBJECT_FIELDS.map(field => [field, match[field]]),
    );
    return { ...patient, ...extra };
  } catch {
    return patient;
  }
}
